import { requestJSON } from '@/lib/api/api';

export function registerPushToken(token: string, accessToken: string) {
  return requestJSON<void>(
    '/me/push-token',
    {
      method: 'POST',
      body: JSON.stringify({ token }),
    },
    accessToken
  );
}
